var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomDsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C27.2386 15 25 17.2386 25 20C25 22.7614 27.2386 25 30 25C32.7614 25 35 22.7614 35 20C34.9961 17.2402 32.7598 15.0039 30 15ZM30 22.8744C28.4145 22.8744 27.1292 21.5891 27.1292 20.0035C27.1292 18.418 28.4145 17.1327 30 17.1327C31.5855 17.1327 32.8708 18.418 32.8708 20.0035C32.8689 21.5883 31.5847 22.8724 30 22.8744Z",
    fill: "#396FC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31.0361V30.747C38 27.0207 34.7993 24 30.8511 24H29.1489C25.2007 24 22 27.0207 22 30.747V31.0361C22 31.5685 22.4572 32 23.0213 32H36.9787C37.5428 32 38 31.5685 38 31.0361ZM24.097 30.0723C24.4531 27.6953 26.6087 25.9281 29.1523 25.9277H30.8545C33.3982 25.9281 35.5537 27.6953 35.9098 30.0723H24.097Z",
    fill: "#396FC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0694 36V40.2375C28.6673 40.7663 27.8059 42.3945 28.0375 44.0778C28.2691 45.761 29.5252 47 31 47C32.4748 47 33.7309 45.761 33.9625 44.0778C34.1941 42.3945 33.3327 40.7663 31.9306 40.2375V36H30.0694ZM32.1385 43.5286C32.1397 44.0611 31.8631 44.542 31.4378 44.7467C31.0125 44.9515 30.5223 44.8398 30.1961 44.4638C29.8698 44.0878 29.7719 43.5216 29.9479 43.0295C30.1239 42.5375 30.5392 42.2165 31 42.2165C31.6276 42.2165 32.1368 42.8034 32.1385 43.5286Z",
    fill: "#396FC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2627 43C20.3953 42.9988 21.4465 42.4104 22.0403 41.4452C22.6341 40.48 22.6859 39.2758 22.177 38.2632L25 35.4346L23.5665 34L20.7401 36.815C19.535 36.205 18.079 36.4002 17.0768 37.3062C16.0746 38.2122 15.733 39.6421 16.2174 40.9038C16.7018 42.1655 17.9122 42.9986 19.2627 43Z",
    fill: "#396FC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7373 43C40.6047 42.9988 39.5535 42.4104 38.9597 41.4452C38.3659 40.48 38.3142 39.2758 38.823 38.2632L36 35.4346L37.4335 34L40.2599 36.815C41.465 36.205 42.921 36.4002 43.9232 37.3062C44.9254 38.2122 45.267 39.6421 44.7826 40.9038C44.2982 42.1655 43.0878 42.9986 41.7373 43Z",
    fill: "#396FC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDsp);
export default __webpack_public_path__ + "static/media/custom_dsp.ffb65b67bb7ffe88c905d1948ba30f29.svg";
export { ForwardRef as ReactComponent };